import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import type { MeResponse } from "@klantpunt/shared";
import { api, ApiError } from "../lib/api";
import { meKey } from "../lib/auth";
import { useToast } from "../lib/toast";

/** Wisselen naar een andere organisatie: gegevens van de vorige gaan uit de cache. */
export function useSwitchOrg() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const toast = useToast();
  return async (orgId: string, to = "/") => {
    try {
      const next = await api<MeResponse>("/me/org", { method: "POST", body: { orgId } });
      qc.clear();
      qc.setQueryData(meKey, next);
      navigate(to, { replace: true });
      if (next.org) toast(`Gewisseld naar ${next.org.name}`);
    } catch (e) {
      toast(e instanceof ApiError ? e.message : "Wisselen mislukt");
    }
  };
}
